<h3-layer-view-settings-popover>
  <ng-container projection-location="sliders">
    <strong class="sub-header">Mask</strong>
    <h3-objectless-view-settings-opacity-slider
      [defaultLayerOpacity]="defaultLayerOpacity"
    ></h3-objectless-view-settings-opacity-slider>

    <strong class="sub-header">Image</strong>
    <div class="popover-grid form-group">
      <h3-view-settings-brightness-slider></h3-view-settings-brightness-slider>
      <h3-view-settings-contrast-slider></h3-view-settings-contrast-slider>
    </div>
  </ng-container>
  <h3-zoom-panel-settings
    projection-location="options"
  ></h3-zoom-panel-settings>
</h3-layer-view-settings-popover>
